var e = !1;
function i(n) {
  return typeof n == "boolean" && (e = n), e;
}
export {
  e as inline,
  i as inlineMock
};
//# sourceMappingURL=mock.mjs.map
